var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8049 0.863649C15.8519 0.655738 16.1481 0.655738 16.1951 0.863649L18.2764 10.0775C18.3068 10.2122 18.4614 10.2763 18.5782 10.2025L26.5651 5.15904C26.7453 5.04523 26.9548 5.25471 26.841 5.43493L21.7975 13.4218C21.7237 13.5386 21.7878 13.6932 21.9225 13.7236L31.1364 15.8049C31.3443 15.8519 31.3443 16.1481 31.1364 16.1951L21.9225 18.2764C21.7878 18.3068 21.7237 18.4614 21.7975 18.5782L26.841 26.5651C26.9548 26.7453 26.7453 26.9548 26.5651 26.841L18.5782 21.7975C18.4614 21.7237 18.3068 21.7878 18.2764 21.9225L16.1951 31.1364C16.1481 31.3443 15.8519 31.3443 15.8049 31.1364L13.7236 21.9225C13.6932 21.7878 13.5386 21.7237 13.4218 21.7975L5.43493 26.841C5.2547 26.9548 5.04523 26.7453 5.15904 26.5651L10.2025 18.5782C10.2763 18.4614 10.2122 18.3068 10.0775 18.2764L0.863649 16.1951C0.655738 16.1481 0.655738 15.8519 0.863649 15.8049L10.0775 13.7236C10.2122 13.6932 10.2763 13.5386 10.2025 13.4218L5.15904 5.43493C5.04523 5.25471 5.25471 5.04523 5.43493 5.15904L13.4218 10.2025C13.5386 10.2763 13.6932 10.2122 13.7236 10.0775L15.8049 0.863649Z",
    fill: "#18B7D4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 7,
    fill: "#18B7D4",
    stroke: "#282828",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.29c0e31afd9810b4dd1cf882940e661b.svg";
export { ForwardRef as ReactComponent };